import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import app from '../../main'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Suppliers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  syncro: false,
  suppliers: []
}

const mutations = {
  ...crud.mutations,
  SET_SYNCRO (state, payload) {
    state.syncro = payload
  }
}

const actions = {
  ...crud.actions,
  async checkSyncro ({ commit }) {
    app.$Progress.start()
    try {
      const response = await axios.get(`/contpaq/syncro`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        const data = typeof response.data === 'object' ? null : response.data

        const actions = {
          false: () => {
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.syncro' }, { root: true })
          },
          true: () => {
            commit('SET_SYNCRO', data)
          },
          null: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.contpaq', text: 'errors.syncro_request_error' }, { root: true })
          },
          default: () => {
            commit('SET_SYNCRO', false)
            commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.connection_error' }, { root: true })
          }
        };

        (actions[data] || actions.default)()
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async syncSuppliers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`contpaq/suppliers`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {

      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  syncro: state => state.syncro,
  suppliers: state => state.suppliers
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
